/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'microphone': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M33 20.5a.613.613 0 0 1-.493.582l-.507.085v3.841c0 3.906-3 6.041-5 6.686v1.174l3 1.364V36H19v-1.769l3-1.364v-1.174c-2-.645-5-2.779-5-6.686v-3.841l-.507-.085c-.27-.044-.493-.306-.493-.581s.225-.5.5-.5H19v5.008c0 3.612 2.984 5.133 5.577 5.133S30 27.953 30 25.008V20h2.5c.275 0 .5.225.5.5zm-13 3.891V21h9v3.391c0 .928-1.045 4.143-4.5 4.143S20 25.318 20 24.391zM29 20h-9v-3.5a4.5 4.5 0 0 1 9 0V20z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/microphone.js